import PropTypes from 'prop-types'
import { filterPostsByTopicSlug } from '../../lib'
import TopicSection from '../topic-section'

const SampleRegistriesView = ({ posts, subTopics }) => (
  <>
    {subTopics.map((childTopic, idx) => (
      <TopicSection
        key={`topic_section_${childTopic.slug}`}
        posts={filterPostsByTopicSlug(posts, childTopic.slug)}
        showAllButton={false}
        showTopics={false}
        topic={{ name: childTopic.name, slug: childTopic.slug }}
      />
    ))}
  </>
)

SampleRegistriesView.propTypes = {
  posts: PropTypes.array,
  subTopics: PropTypes.array,
}

export default SampleRegistriesView
